import {
    Card,
    CardContent,
    Grid,
    Container,
    Dialog,
    DialogTitle,
    Divider,
    Typography
} from '@mui/material'
import { Formik } from 'formik'
import React from 'react'
import { ActionButton } from '../../../utils/ui_utils'

function FileExportDialog({
    initialValue,
    visible,
    onClose,
    counterGroupsMsg,
    countersMsg,
    itemsMsg,
    counterGroupsIcon,
    countersIcon,
    itemsIcon,
    okButtonStatus,
    okSubmit
}) {


    if (initialValue == undefined)
        initialValue = {
            name: '',
        }

    const handleSubmit = async (value, { resetForm, setErrors, setStatus, setSubmitting }) => {
        okSubmit()
        onClose()
    }

    return (
        <div>
            <Dialog maxWidth={'sm'} fullWidth anchor="right" backdrop="static" variant="temporary" open={visible}>
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    Export Files
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }} >
                    <Formik
                        onSubmit={handleSubmit}
                        initialValues={initialValue}
                    >
                        {({
                            handleSubmit,
                        }) => (

                            <form onSubmit={handleSubmit}>
                                <Divider my={2} />
                                <Card >
                                    <CardContent>
                                        <Grid container spacing={5} style={{ paddingTop: 10, paddingLeft: 10 }}>
                                            <Grid item>
                                                <Grid container ><Grid item sx={{ marginRight: 10 }} ><Typography variant='subtitle1' gutterBottom fontWeight={'bold'}>{counterGroupsMsg}</Typography></Grid><Grid item ><Typography variant='subtitle1'>{counterGroupsIcon}</Typography></Grid></Grid>
                                                <Grid container sx={{ justifyContent: "space-between" }}><Grid item ><Typography variant='subtitle1' gutterBottom fontWeight={'bold'}>{countersMsg}</Typography></Grid><Grid item ><Typography variant='subtitle1'>{countersIcon}</Typography></Grid></Grid>
                                                <Grid container sx={{ justifyContent: "space-between" }}><Grid item ><Typography variant='subtitle1' gutterBottom fontWeight={'bold'}>{itemsMsg}</Typography></Grid><Grid item ><Typography variant='subtitle1'>{itemsIcon}</Typography></Grid></Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent="flex-end">
                                            <Grid item>
                                                <ActionButton variant="outlined" size='medium' type="submit" mt={8} disabled={okButtonStatus} >
                                                    Ok
                                                </ActionButton>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Dialog>
        </div>
    )
}

export default FileExportDialog